import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Components
 */
import DocumentCard from './DocumentCard';

const styles = {
    documentList: {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    },
};

/**
 * List of PRL documents
 * @component
 * @param {Object[]} items the documents
 * @param {string} workId the work ID
 */
const ListDocuments = ({ items, workId = null }) => {
    const { t } = useTranslation();

    if (!Array.isArray(items) || items.length < 1) {
        return (
            <div>{t('noResults')}</div>
        );
    }

    return (
        <div style={styles.documentList}>
            {items.map(item => (
                <DocumentCard key={item.id} document={item} workId={workId} />
            ))}
        </div>
    );
};

export default ListDocuments;